// Constants
import { SHOW_MODAL, HIDE_MODAL } from '~/data/constants/modal-constants';

// MODAL ACTIONS
function showModal(type, properties) {
  return {
    type: SHOW_MODAL,
    payload: {
      type,
      properties,
    },
  };
}

function hideModal() {
  return {
    type: HIDE_MODAL,
  };
}

export const modalActions = {
  showModal,
  hideModal,
};



// WEBPACK FOOTER //
// ./src/redux/actions/modal-actions.jsx